import React, { ReactNode, useEffect } from "react";

type Props = {
  onClose: () => void;
  children: ReactNode;
  width?: string;
};

export const Modal: React.FC<Props> = ({
  onClose,
  children,
  width = "400px",
}) => {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  return (
    <div className={"modal modal-open !z-[4]"} onClick={onClose}>
      {/* role/aria-modal (QA batch 17, PROF-040): the confirm windows are real
          dialogs for screen readers and checks (and the help button hides). */}
      <div
        className={
          // Phones: never wider than the screen (QA PHONE-016; desktop unchanged).
          "relative rounded-2xl bg-white p-6 font-Manrope shadow-modal max-md:max-w-[calc(100vw-24px)] max-md:p-4"
        }
        style={{ width }}
        role={"dialog"}
        aria-modal={"true"}
        onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
};
